import React from "react";
import Text from "@/components/ui/text";

const BetaBadge: React.FC = () => (
  <div className="px-1 py-[2px] rounded-md border-[0.5px] border-border-border2 flex items-center justify-center">
    <Text variant="smBodyTertiary">BETA</Text>
  </div>
);

export default BetaBadge;
